var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"builder-wrapper"},[_c('BuilderSidebar'),_c('div',{staticClass:"main-container",class:_vm.isSidebarOpen ? 'sidebar-open' : 'sidebar-close'},[_c('BuilderTopbar'),_c('BuilderMain')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }